<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <p
        class="titleText"
        :style="{ backgroundImage: `url(${homeTitle})` }"
      ></p>
    </section>
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <div
          class="chartPanel-child topLeft"
          v-loading="topLeftLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topLeftTimelineData"
              :key="item"
              :class="{ active: index === topLeftTimelineActiveIndex }"
              @click="topLeftChartTimelineProgressChange(index, item)"
            >
              {{ item }}
            </li>
          </ul>
          <div slot="empty" class="figure-data" v-if="!topLeftChartData.length">
            <div class="nodate">
              <img src="../../../assets/images/pg-nodata-dark.png" alt="" />
              <p>无数据</p>
            </div>
          </div>
          <div class="chartPanel-child-chartArea" ref="topLeftChartDOM"></div>
        </div>
        <!--topCenter-->
        <div class="chartPanel-child topCenter">
          <ul class="dataBubbleList">
            <router-link class="dataBubble" to="/baseComparyList" tag="li">
              <p class="dataBubble__header">园区服务企业总数量</p>
              <div class="dataBubble__content">
                {{ topTotalNumber.comparyNum }}
              </div>
            </router-link>
            <router-link
              class="dataBubble"
              :to="{
                path: '/monitCenterStorageList',
                query: { storageType: 1 }
              }"
              tag="li"
            >
              <p class="dataBubble__header">今日新增园区服务企业量</p>
              <div class="dataBubble__content">
                {{ topTotalNumber.storageNum }}
              </div>
            </router-link>
          </ul>
        </div>
        <!--topRight-->
        <div
          class="chartPanel-child topRight"
          v-loading="topRightLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topRightTimelineData"
              :key="item"
              :class="{ active: index === topRightTimelineActiveIndex }"
              @click="topRightChartTimelineProgressChange(index, item)"
            >
              {{ item }}
            </li>
          </ul>
          <div
            slot="empty"
            class="figure-data"
            v-if="!topRightChartData.length"
          >
            <div class="nodate">
              <img src="../../../assets/images/pg-nodata-dark.png" alt="" />
              <p>无数据</p>
            </div>
          </div>
          <div class="chartPanel-child-chartArea" ref="topRightChartDOM"></div>
        </div>
        <!--middleLeft-->
        <div
          class="chartPanel-child middleLeft"
          v-loading="middleLeftLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in middleLeftTimelineData"
              :key="item"
              :class="{ active: index === middleLeftTimelineActiveIndex }"
              @click="middleLeftChartTimelineProgressChange(index, item)"
            >
              {{ item }}
            </li>
          </ul>
          <div
            slot="empty"
            class="figure-data"
            v-if="!middleLeftChartData.length"
          >
            <div class="nodate">
              <img src="../../../assets/images/pg-nodata-dark.png" alt="" />
              <p>无数据</p>
            </div>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="middleLeftChartDOM"
          ></div>
        </div>
        <!--middleCenter-->
        <div
          class="chartPanel-child middleCenter"
          v-loading="mapLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide" style="top: initial; bottom: 45px">
            <li
              v-for="(item, index) in mapChartTimelineData"
              :key="item"
              :class="{ active: index === mapChartTimelineActiveIndex }"
              @click="mapChartTimelineProgressChange(index)"
            >
              {{ item }}
            </li>
          </ul>
          <div class="chartPanel-child-chartArea" ref="mapChartDOM"></div>
        </div>

        <!--middleRight-->
        <div
          class="chartPanel-child middleRight"
          v-loading="middleRightLoading"
          element-loading-background="rgba(0, 0, 0, 0.7)"
        >
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in middleRightTimelineData"
              :key="item"
              :class="{ active: index === middleRightTimelineActiveIndex }"
              @click="middleRightChartTimelineProgressChange(index, item)"
            >
              {{ item }}
            </li>
          </ul>
          <div
            slot="empty"
            class="figure-data"
            v-if="!middleRightChartData.length"
          >
            <div class="nodate">
              <img src="../../../assets/images/pg-nodata-dark.png" alt="" />
              <p>无数据</p>
            </div>
          </div>
          <div
            class="chartPanel-child-chartArea"
            ref="middleRightChartDOM"
          ></div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
// 顶部中间平台名称图片
const homeTitle = require(`@/assets/images/monitorBorad/flowRank/title.png`);
// mixins
// import resizeListener from "_private/mixins/resizeListener";

// interface
import {
  fetchCompanyFlowInTopN,
  fetchCompanyFlowOutTopN,
  fetchGoodsFlowInDetail,
  fetchGoodsFlowOutDetail,
  fetchStorageCompanyNum,
  fetchCityDistribution
} from "@/api/board/storageFlowRank.js";

// charts setting
import { formatMapData } from "./chartConfig.js";

export default {
  // mixins: [resizeListener],
  data() {
    return {
      homeTitle: Object.freeze(homeTitle), // 顶部中间平台名称图片
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 30, // 刷新数据时间间隔

      /************ topLeft ****************/
      topLeftChartInstance: null, // 左上角图表实例
      topLeftLoading: false, // 左上角数据正在加载
      topLeftChartData: [],
      topLeftAutoHighlightTimer: null,
      topLeftTimelineData: ["昨日", "近七日", "近一月"],
      topLeftTimelineActiveIndex: 0,

      /*********** topRight ********************/
      topRightChartInstance: null, // 右上角图表实例
      topRightLoading: false, // 右上角数据正在加载
      topRightChartData: [],
      topRightAutoHighlightTimer: null,
      topRightTimelineData: ["昨日", "近七日", "近一月"],
      topRightTimelineActiveIndex: 0,

      /*********** middleLeft ********************/
      middleLeftChartInstance: null, // 中部左侧图表实例
      middleLeftLoading: false, // 中部左侧数据正在加载
      middleLeftChartData: [],
      middleLeftAutoHighlightTimer: null,
      middleLeftTimelineData: ["近七日", "近一月"],
      middleLeftTimelineActiveIndex: 0,

      /*********** middleRight ********************/
      middleRightChartInstance: null, // 中部右侧图表实例
      middleRightLoading: false, // 中部右侧数据正在加载
      middleRightChartData: [],
      middleRightAutoHighlightTimer: null,
      middleRightTimelineData: ["近七日", "近一月"],
      middleRightTimelineActiveIndex: 0,

      /************* centerMap ********************/
      mapChartInstance: null, // 地图图表实例
      mapOutlineGeo: {}, // 地图地区外轮廓geo数据
      mapChartData: [],
      mapChartTimelineData: ["流入量", "流出量"],
      mapChartTimelineActiveIndex: 0,
      mapChartHighlightTimer: null,
      // 顶部总数据项展示
      topTotalNumber: {
        comparyNum: 0, // 园区服务企业总数量
        addComparyNum: 0 //今日新增园区服务企业量
      },
      mapLoading: false,
      chartTimer: null
    };
  },

  created() {
    // 初始化中间地图geo数据，获取业务数据
    this.initCenterMap();
    // 商品流入量top5企业
    this.fetchTopLeftChartData("昨日");
    // 商品流出量top5企业
    this.fetchTopRightData("昨日");
    // 商品流入波动图
    this.fetchMiddleLeftChartData("近七日");
    // 商品流出波动图
    this.fetchMiddleRightChartsData("近七日");
    // 园区服务企业总数
    this.queryNumberByRealTime();
  },

  mounted() {
    this.setCLockTimeInterval();
    this.reloadData();
    this.resizeListener();
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.chartTimer);
    clearInterval(this.topLeftAutoHighlightTimer);
    clearInterval(this.topRightAutoHighlightTimer);
    clearInterval(this.middleLeftAutoHighlightTimer);
    clearInterval(this.middleRightAutoHighlightTimer);
    clearInterval(this.mapChartHighlightTimer);
  },

  methods: {
    //resize图表
    resizeListener() {
      window.addEventListener("resize", () => {
        if (this.topLeftChartInstance) {
          this.topLeftChartInstance.resize();
        }
        if (this.topRightChartInstance) {
          this.topRightChartInstance.resize();
        }
        if (this.middleLeftChartInstance) {
          this.middleLeftChartInstance.resize();
        }
        if (this.middleRightChartInstance) {
          this.middleRightChartInstance.resize();
        }
        if (this.mapChartInstance) {
          this.mapChartInstance.resize();
        }
      });
    },
    //获取选择的时间
    getDate(item) {
      let timeMap = new Map([
        ["昨日", 1],
        ["近七日", 7],
        ["近一月", 30]
      ]);
      let time = timeMap.get(item);
      if (time === 1) {
        return {
          startTime: moment()
            .subtract(1, "day")
            .startOf("days")
            .valueOf(),
          endTime: moment()
            .subtract(1, "day")
            .endOf("days")
            .valueOf()
        };
      } else {
        return {
          startTime: moment()
            .subtract(time - 1, "day")
            .startOf("days")
            .valueOf(),
          endTime: moment()
            // .subtract(1, "day")
            .endOf("days")
            .valueOf()
        };
      }
    },

    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },

    // 实时查询今日新增园区服务企业量个数
    queryNumberByRealTime() {
      fetchStorageCompanyNum().then(res => {
        let {
          code,
          result: { value, value2 }
        } = res;
        if (res && code == 1) {
          this.topTotalNumber.comparyNum = value;
          this.topTotalNumber.storageNum = value2;
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },

    /************************** topLeft ************************************/
    // 左上角图表进度更改
    topLeftChartTimelineProgressChange(index, item) {
      this.topLeftTimelineActiveIndex = index;
      this.topLeftChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
      // 获取商品流入量TOP5企业数据
      this.fetchTopLeftChartData(item);
    },

    // 获取商品流入量TOP5企业数据
    fetchTopLeftChartData(timeType) {
      this.topLeftLoading = true;
      let params = this.getDate(timeType);
      fetchCompanyFlowInTopN(params)
        .then(({ code, result, message }) => {
          if (code === 1 && Array.isArray(result)) {
            this.topLeftChartData = result;
          } else {
            this.errorMessage(message || "获取商品流入量TOP5企业数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取商品流入量TOP5企业数据失败");
        })
        .finally(() => {
          this.topLeftLoading = false;
          this.initTopLeftChart();
        });
    },

    // 初始化左上角图表
    initTopLeftChart() {
      if (this.topLeftChartInstance) {
        this.topLeftChartInstance.clear();
      } else {
        this.topLeftChartInstance = Echarts.init(this.$refs.topLeftChartDOM);
        this.topLeftChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topLeftTimelineActiveIndex = currentIndex;
        });
      }
      const timelineData = this.topLeftTimelineData;
      const companyName = this.topLeftChartData.map(item => {
        return item.companyName;
      });
      const tagsName = this.topLeftChartData.map(item => {
        return `流入${item.warehouseNum}批次`;
      });
      const DATA_LENGTH = this.topLeftChartData.length;
      const options = [
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "昨日",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#008aff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#4348ff" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(67, 72, 255, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "近七日",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3eeed4" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00a24c" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 161, 76, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 161, 76, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "近一月",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#f1bb4b" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#d76b15" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(215, 107, 21, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(215, 107, 21, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        }
      ];

      this.topLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "商品流入量{style1|TOP5}企业",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(26),
              rich: {
                style1: {
                  color: "#ffea94"
                }
              }
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              let {
                axisValue,
                value: { goodsNum }
              } = item[0];
              let idx = this.topLeftTimelineActiveIndex;
              return `${axisValue}<br />${timelineData[idx]}:${goodsNum}`;
            }
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(-25),
            right: this.calcXDirectionSizeByPercent(60),
            top: this.calcYDirectionSizeByPercent(80),
            left: this.calcXDirectionSizeByPercent(50)
          },
          dataset: {
            source: this.topLeftChartData
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 29,
            data: timelineData
          },
          xAxis: {
            type: "value",
            show: false,
            boundaryGap: false,
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false },
            axisLine: { show: false }
          },
          yAxis: {
            type: "category",
            inverse: true,
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false },
            axisLine: { show: false, lineStyle: { color: "#6173a3" } }
          },
          series: [
            {
              show: true,
              type: "bar",
              smooth: true,
              barMinHeight: this.calcXDirectionSizeByPercent(75),
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 30, 30, 0],
                  color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: "#1c2648" },
                    { offset: 1, color: "#3baffe" }
                  ])
                },
                emphasis: {
                  barBorderRadius: 30
                }
              },
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                    fontSize: this.calcXDirectionSizeByPercent(14)
                  },
                  position: "right",
                  formatter: function(data) {
                    let {
                      data: { goodsNum }
                    } = data;
                    return goodsNum ? goodsNum + "件" : "";
                  }
                }
              },
              symbolSize: this.calcXDirectionSizeByPercent(6) // 图例大小
            },
            //年份
            {
              show: true,
              type: "bar",
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: 200,
                  color: "transparent"
                }
              },
              label: {
                normal: {
                  show: true,
                  position: [0, "-75"],
                  textStyle: {
                    fontSize: this.calcXDirectionSizeByPercent(16),
                    color: "#bad7ff"
                  },
                  formatter: function(data) {
                    let idx = data.dataIndex;
                    return `{styleA|${idx + 1}}${companyName[idx]}`;
                  },
                  rich: {
                    styleA: {
                      color: "#2d81c1",
                      fontStyle: "italic",
                      fontWeight: "bold",
                      padding: [0, 8, 0, -25],
                      fontSize: this.calcXDirectionSizeByPercent(30)
                    }
                  }
                }
              }
            },
            {
              show: true,
              type: "bar",
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: 200,
                  color: "transparent"
                }
              },
              label: {
                normal: {
                  show: true,
                  position: [0, "-65"],
                  textStyle: {
                    fontSize: this.calcXDirectionSizeByPercent(14),
                    color: "#9195a0"
                  },
                  formatter: function(data) {
                    return tagsName[data.dataIndex];
                  }
                }
              }
            }
          ]
        },
        options
      });

      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      let idx = this.topLeftTimelineActiveIndex;
      clearInterval(this.topLeftAutoHighlightTimer);
      this.topLeftAutoHighlightTimer = setInterval(() => {
        this.topLeftChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });
        idx++;
        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
        if (idx === timelineData.length) {
          idx = 0;
        }
        let item = timelineData[idx];
        // 获取商品流入波动图数据
        this.topLeftChartTimelineProgressChange(idx, item);
      }, 1e3 * 30);
    },

    /************************** topRight ************************************/
    // 商品流出量TOP5企业
    fetchTopRightData(timeType) {
      this.topRightLoading = true;
      let params = this.getDate(timeType);
      fetchCompanyFlowOutTopN(params)
        .then(({ code, result, message }) => {
          if (code === 1 && Array.isArray(result)) {
            this.topRightChartData = result;
          } else {
            this.errorMessage(message || "商品流出量TOP5企业失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("商品流出量TOP5企业失败");
        })
        .finally(() => {
          this.topRightLoading = false;
          this.initTopRightChart();
        });
    },

    // 初始化右上角图表
    initTopRightChart() {
      if (this.topRightChartInstance) {
        this.topRightChartInstance.clear();
      } else {
        this.topRightChartInstance = Echarts.init(this.$refs.topRightChartDOM);
        this.topRightChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topRightTimelineActiveIndex = currentIndex;
        });
      }
      const timelineData = this.topRightTimelineData;
      const DATA_LENGTH = this.topRightChartData.length;
      const companyName = this.topRightChartData.map(item => {
        return item.companyName;
      });
      const tagsName = this.topRightChartData.map(item => {
        return `流出${item.warehouseNum}批次`;
      });
      const options = [
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "昨日",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#008aff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#4348ff" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(67, 72, 255, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "近七日",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3eeed4" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00a24c" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 161, 76, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0, 161, 76, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["companyName", "goodsNum"]
          },
          series: [
            {
              name: "近一月",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#f1bb4b" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#d76b15" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(215, 107, 21, 0.6)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(215, 107, 21, 0.1)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        }
      ];

      this.topRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "商品流出量{styleA|TOP5}企业",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(26),
              rich: {
                styleA: {
                  color: "#ffea94"
                }
              }
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              0,
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              let {
                axisValue,
                value: { goodsNum }
              } = item[0];
              let idx = this.topRightTimelineActiveIndex;
              return `${axisValue}<br />${timelineData[idx]}:${goodsNum}`;
            }
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 29,
            data: timelineData
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(30),
            right: this.calcXDirectionSizeByPercent(60),
            top: this.calcYDirectionSizeByPercent(55),
            left: this.calcXDirectionSizeByPercent(38)
          },
          dataset: {
            source: this.topRightChartData
          },
          xAxis: {
            type: "value",
            show: false,
            boundaryGap: false,
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false },
            axisLine: { show: false }
          },
          yAxis: {
            type: "category",
            inverse: true,
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLine: { show: false },
            axisLine: { show: false, lineStyle: { color: "#6173a3" } }
          },
          series: [
            {
              show: true,
              type: "bar",
              smooth: true,
              barMinHeight: 75,
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: [0, 30, 30, 0],
                  color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: "#1c2648" },
                    { offset: 1, color: "#efba4c" }
                  ])
                },
                emphasis: {
                  barBorderRadius: 30
                }
              },
              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                    fontSize: this.calcXDirectionSizeByPercent(14)
                  },
                  position: "right",
                  formatter: function(data) {
                    let {
                      data: { goodsNum }
                    } = data;
                    return goodsNum ? goodsNum + "件" : "";
                  }
                }
              },
              symbolSize: this.calcXDirectionSizeByPercent(6) // 图例大小
            },
            //年份
            {
              show: true,
              type: "bar",
              barGap: "-20%",
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: 200,
                  color: "transparent"
                }
              },
              label: {
                normal: {
                  show: true,
                  position: [0, "-55"],
                  textStyle: {
                    fontSize: this.calcXDirectionSizeByPercent(16),
                    color: "#bad7ff"
                  },
                  formatter: function(data) {
                    let idx = data.dataIndex;
                    return `{styleA|${idx + 1}}${companyName[idx]}`;
                  },
                  rich: {
                    styleA: {
                      color: "#b08946",
                      fontStyle: "italic",
                      fontWeight: "bold",
                      padding: [0, 8, 0, -30],
                      fontSize: this.calcXDirectionSizeByPercent(30)
                    }
                  }
                }
              }
            },
            {
              show: true,
              type: "bar",
              barGap: "-15%",
              barWidth: this.calcXDirectionSizeByPercent(28),
              itemStyle: {
                normal: {
                  barBorderRadius: 200,
                  color: "transparent"
                }
              },
              label: {
                normal: {
                  show: true,
                  position: [0, "-40"],
                  textStyle: {
                    fontSize: this.calcXDirectionSizeByPercent(14),
                    color: "#9195a0"
                  },
                  formatter: function(data) {
                    return tagsName[data.dataIndex];
                  }
                }
              }
            }
          ]
        },
        options
      });

      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      let idx = this.topRightTimelineActiveIndex;
      clearInterval(this.topRightAutoHighlightTimer);
      this.topRightAutoHighlightTimer = setInterval(() => {
        this.topRightChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });
        idx++;
        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
        if (idx === timelineData.length) {
          idx = 0;
        }
        let item = timelineData[idx];
        // 获取商品流入波动图数据
        this.topRightChartTimelineProgressChange(idx, item);
      }, 1e3 * 30);
    },
    // 右上角图表进度更改
    topRightChartTimelineProgressChange(index, item) {
      this.topRightTimelineActiveIndex = index;
      this.topRightChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
      // 商品流出量TOP5企业
      this.fetchTopRightData(item);
    },

    /************************** MiddleLeft ************************************/
    // 左上角图表进度更改
    middleLeftChartTimelineProgressChange(index, item) {
      this.middleLeftTimelineActiveIndex = index;
      this.middleLeftChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
      // 获取商品流入波动图数据
      this.fetchMiddleLeftChartData(item);
    },
    // 获取商品流入波动图数据
    fetchMiddleLeftChartData(timeType) {
      this.middleLeftLoading = true;
      let params = this.getDate(timeType);
      fetchGoodsFlowInDetail(params)
        .then(({ code, result, message }) => {
          if (code === 1 && Array.isArray(result)) {
            this.middleLeftChartData = result;
          } else {
            this.errorMessage(message || "商品流入波动图数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("商品流入波动图数据失败");
        })
        .finally(() => {
          this.middleLeftLoading = false;
          this.initMiddleLeftChart();
        });
    },
    // 初始化中部左侧图表
    initMiddleLeftChart() {
      if (this.middleLeftChartInstance) {
        this.middleLeftChartInstance.clear();
      } else {
        this.middleLeftChartInstance = Echarts.init(
          this.$refs.middleLeftChartDOM
        );
        this.middleLeftChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.middleLeftTimelineActiveIndex = currentIndex;
          }
        );
      }
      const timelineData = this.middleLeftTimelineData;
      const DATA_LENGTH = this.middleLeftChartData.length;
      const option = [
        {
          dataset: {
            dimensions: ["name", "value3"]
          },
          series: [
            {
              name: "近七日",
              lineStyle: {
                color: "#3bafff",
                shadowColor: "rgba(8, 173, 231, 0.2)"
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["name", "value3"]
          },
          series: [
            {
              name: "近一月",
              lineStyle: {
                color: "#3bafff",
                shadowColor: "rgba(8, 173, 231, 0.2)"
              }
            }
          ]
        }
      ];
      this.middleLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "商品流入波动图",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [0, 0, 0, this.calcXDirectionSizeByPercent(10)]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              let [node] = item;
              let {
                data: { value3 }
              } = node;
              let idx = this.middleLeftTimelineActiveIndex;
              return `${timelineData[idx]}:${value3}`;
            }
          },
          grid: {
            right: "5%",
            bottom: "12%"
          },
          dataset: {
            source: this.middleLeftChartData
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 29000,
            data: timelineData
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisTick: {
              // 坐标刻度
              show: false
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                color: "#3a4272"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#909198"
              }
            }
          },
          yAxis: {
            type: "value",
            axisTick: {
              show: false
            },
            axisLine: {
              // 坐标轴
              lineStyle: {
                color: "#3a4272"
              }
            },
            splitLine: {
              // 分割线
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#909198"
              }
            }
          },
          series: [
            {
              show: true,
              type: "line",
              barCategoryGap: "50%",
              symbol: "circle",
              symbolSize: this.calcXDirectionSizeByPercent(6),
              lineStyle: {
                color: "#3bafff"
              },
              itemStyle: {
                normal: {
                  color: "#3bafff",
                  shadowColor: "rgba(0,0,0,0.3)"
                }
              },
              areaStyle: {
                normal: {
                  color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#3bafff" },
                    { offset: 1, color: "rgba(0,0,0,0)" }
                  ])
                }
              },
              label: {
                show: true,
                textStyle: {
                  color: "#909198"
                }
              }
            }
          ]
        },
        option
      });
      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      let idx = this.middleLeftTimelineActiveIndex;
      clearInterval(this.middleLeftAutoHighlightTimer);
      this.middleLeftAutoHighlightTimer = setInterval(() => {
        this.middleLeftChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });
        idx++;
        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
        if (idx === timelineData.length) {
          idx = 0;
        }
        let item = timelineData[idx];
        // 获取商品流入波动图数据
        this.middleLeftChartTimelineProgressChange(idx, item);
      }, 30000);
    },

    /************************** MiddleRight ************************************/
    // 中部右侧图表进度更改
    middleRightChartTimelineProgressChange(index, item) {
      this.middleRightTimelineActiveIndex = index;
      this.middleRightChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
      // 商品流出波动图
      this.fetchMiddleRightChartsData(item);
    },
    // 商品流出波动图
    fetchMiddleRightChartsData(timeType) {
      const fetchDataFun = () => {
        this.middleRightLoading = true;
        let params = this.getDate(timeType);
        fetchGoodsFlowOutDetail(params)
          .then(({ code, result, message }) => {
            if (code === 1 && result) {
              this.middleRightChartData = result;
            } else {
              this.errorMessage(
                message || "获取综合在线率及温度合格率排行TOP5数据失败"
              );
            }
          })
          .catch(err => {
            console.log(err);
            this.errorMessage("获取综合在线率及温度合格率排行TOP5数据失败");
          })
          .finally(() => {
            this.initMiddleRightChart();
            this.middleRightLoading = false;
          });
      };
      fetchDataFun();
    },
    // 初始化中部右侧图表
    initMiddleRightChart() {
      if (this.middleRightChartInstance) {
        this.middleRightChartInstance.clear();
      } else {
        this.middleRightChartInstance = Echarts.init(
          this.$refs.middleRightChartDOM
        );
        this.middleRightChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.middleRightTimelineActiveIndex = currentIndex;
          }
        );
      }
      const timelineData = this.middleRightTimelineData;
      const DATA_LENGTH = this.middleRightChartData.length;
      const option = [
        {
          dataset: {
            dimensions: ["time", "value"]
          },
          series: [
            {
              name: "近七日",
              lineStyle: {
                color: "#f1bb4c",
                shadowColor: "rgba(8, 173, 231, 0.2)"
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["time", "value"]
          },
          series: [
            {
              name: "近一月",
              lineStyle: {
                color: "#f1bb4c",
                shadowColor: "rgba(8, 173, 231, 0.2)"
              }
            }
          ]
        }
      ];
      this.middleRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "商品流出波动图",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [0, 0, 0, this.calcXDirectionSizeByPercent(10)]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              let [node] = item;
              let {
                data: { value3 }
              } = node;
              let idx = this.middleRightTimelineActiveIndex;
              return `${timelineData[idx]}:${value3}`;
            }
          },
          grid: {
            right: "5%",
            bottom: "12%"
          },
          dataset: {
            source: this.middleRightChartData
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 29,
            data: timelineData
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisTick: {
              // 坐标刻度
              show: false
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                color: "#3a4272"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#909198"
              }
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            axisLine: {
              // 坐标轴
              lineStyle: {
                color: "#3a4272"
              }
            },
            splitLine: {
              // 分割线
              show: false
            },
            axisLabel: {
              interval: 2,
              textStyle: {
                color: "#909198"
              }
            }
          },
          series: {
            type: "line",
            barCategoryGap: "50%",
            symbol: "circle",
            symbolSize: this.calcXDirectionSizeByPercent(6),
            lineStyle: {
              color: "#f1bb4c"
            },
            itemStyle: {
              normal: {
                color: "#f1bb4c",
                shadowColor: "rgba(0,0,0,0.3)"
              }
            },
            areaStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: " #f1bb4c" },
                  { offset: 1, color: "rgba(255,255,255,0)" }
                ])
              }
            },
            label: {
              show: true,
              textStyle: {
                color: "#909198"
              }
            }
          }
        },
        option
      });
      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      let idx = this.middleRightTimelineActiveIndex;
      clearInterval(this.middleRightAutoHighlightTimer);
      this.middleRightAutoHighlightTimer = setInterval(() => {
        this.middleRightChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });
        idx++;
        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
        if (idx === timelineData.length) {
          idx = 0;
        }
        let item = timelineData[idx];
        // 获取商品流入波动图数据
        this.middleRightChartTimelineProgressChange(idx, item);
      }, 1e3 * 30);
    },

    /************************** centerMap ************************************/
    mapChartTimelineProgressChange(index) {
      this.mapChartTimelineActiveIndex = index;
      // this.mapChartInstance.dispatchAction({
      //   type: "timelineChange",
      //   currentIndex: index
      // });
      // 获取商品流入波动图数据
      this.initCenterMap();
    },
    // 初始化中间地图geo数据，获取业务数据
    async initCenterMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`)
      ];
      let [inlineGeo, outlineGeo] = await Promise.all(geoPromises);

      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      // 获取中部地图数据
      this.fetchCenterMapData();
    },

    // 获取中部地图数据
    fetchCenterMapData() {
      this.mapLoading = true;
      let params = {
        flowIn: !this.mapChartTimelineActiveIndex
      };
      fetchCityDistribution(params)
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            this.mapChartData = formatMapData(result);
          } else {
            this.errorMessage(message || "获取地图数据数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取地图数据数据失败");
        })
        .finally(() => {
          this.mapLoading = false;
          this.initMapChart();
        });
    },

    // 初始化中部地图
    initMapChart() {
      if (this.mapChartInstance) {
        this.mapChartInstance.clear();
        this.mapChartInstance.dispose();
        this.mapChartInstance = null;
      }
      this.mapChartInstance = Echarts.init(this.$refs.mapChartDOM);
      this.mapChartInstance.on("timelinechanged", ({ currentIndex }) => {
        this.mapChartTimelineActiveIndex = currentIndex;
      });
      let idx = this.mapChartTimelineActiveIndex;
      const timelineData = this.mapChartTimelineData;
      const option = {
        tooltip: {
          show: true
        },
        visualMap: {
          left: this.calcXDirectionSizeByPercent(30),
          bottom: this.calcXDirectionSizeByPercent(45),
          orient: "horizontal",
          itemHeight: this.calcXDirectionSizeByPercent(8),
          itemWidth: this.calcXDirectionSizeByPercent(15),
          align: "left",
          textGap: 5,
          formatter: (value, value2) => {
            return value + "-" + value2 + "件"; // 范围标签显示内容。
          },
          pieces: [
            {
              gt: 0,
              lte: 2000,
              color: idx ? "#403425" : "#1d314c"
            },
            {
              gt: 2000,
              lte: 4000,
              color: idx ? "#68542d" : "#244f79"
            },
            {
              gt: 4000,
              lte: 6000,
              color: idx ? "#9a783a" : "#2b70a7"
            },
            {
              gt: 6000,
              lte: 8000,
              color: idx ? "#c49942" : "#328fd2"
            },
            {
              gt: 8000,
              lte: 10000,
              color: idx ? "#f1bb4c" : "#3bb0ff"
            }
          ],
          textStyle: {
            color: "#7b89dc",
            fontSize: 12
          },
          outOfRange: {
            color: "#999"
          }
        },
        geo: [
          {
            map: "outlineMap",
            roam: false,
            zoom: 1,
            top: "8%",
            right: "5%",
            bottom: "35%",
            left: "5%",
            label: {
              show: false,
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                shadowBlur: 20
              }
            },
            hoverAnimation: false,
            show: true
          },
          {
            name: "inlineMap",
            type: "map",
            map: "inlineMap",
            roam: false,
            zoom: 1,
            top: "8%",
            right: "5%",
            bottom: "35%",
            left: "5%",
            tooltip: {
              show: true
            },
            label: {
              normal: {
                show: true,
                position: "inside", //显示位置
                offset: [0, 0], //偏移设置
                color: "#fff",
                // formatter: "{b}", //圆环显示文字
                fontWeight: "lighter",
                fontSize: 12
              },
              emphasis: {
                color: "#ffffff",
                show: true
              }
            },
            itemStyle: {
              normal: {
                areaColor: idx ? "#121a4a" : "#173a72",
                borderWidth: 3, //设置外层边框
                borderColor: idx ? "#f1bb4c" : "#3e59ce",
                shadowColor: idx ? "rgba(241,187,76, 1)" : "rgba(62,89,206, 1)",
                shadowBlur: 30
              },
              emphasis: {
                areaColor: idx
                  ? "rgba(0, 0, 0, 0.5)"
                  : "rgba(61, 178, 255, 0.75)"
              }
            }
          }
        ],
        series: [
          {
            name: idx ? "流出量" : "流入量",
            type: "map",
            coordinateSystem: "geo",
            geoIndex: 1,
            hoverAnimation: false,
            itemStyle: {
              color: "#afa3f5",
              shadowBlur: 2,
              opacity: 0.3,
              shadowColor: "#fff"
            },
            emphasis: {
              itemStyle: {
                opacity: 1,
                shadowBlur: 7
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                if (params.data) {
                  let {
                    seriesName,
                    name,
                    data: { total }
                  } = params;
                  let result = seriesName + "<br />" + name + "：" + total;
                  return result;
                } else {
                  return "";
                }
              }
            },
            data: this.mapChartData
          }
        ]
      };
      this.mapChartInstance.setOption(option);
      clearInterval(this.mapChartHighlightTimer);
      this.mapChartHighlightTimer = setInterval(() => {
        idx++;
        if (idx === timelineData.length) {
          idx = 0;
        }
        // 获取地图数据
        this.mapChartTimelineProgressChange(idx);
      }, 30000);
    },

    // 按照时间重新加载数据
    reloadData() {
      this.chartTimer = setInterval(() => {
        this.queryNumberByRealTime();
      }, this.reloadDataTime);
    },

    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      return size;
      // 目前此页面不需要自适应，则注释下计算字体
      // return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      return size;
      // 目前此页面不需要自适应，则注释下计算字体
      // return (size / 1080) * this.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(../../../assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(../../../assets/ledFont/LEDNum.eot?#iefix)
      format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("../../../assets/ledFont/LEDNum.woff")
      format("woff"),
    local("LEDNum"), url("../../../assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}

$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #09121b;
  background-image: url("../../../assets/images/bigScreen/bigScreenBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 166px;
    padding-top: 10px;
    background-image: url("../../../assets/images/monitorBorad/title-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    p {
      margin: 0;
    }

    .titleInfo {
      font-family: "LEDNumber";
      color: #3f83ff;
      font-size: 22px;
      word-spacing: 1em;
      margin-left: 35px;
    }

    .titleText {
      width: 260px;
      height: 30px;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (10px / $layout-width) * 100%;
          top: (70px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (611px / $layout-height) * 100%;
          background-image: url("../../../assets/images/monitorBorad/leftBorder.png");
        }

        &.topCenter {
          left: 0;
          right: 0;
          top: (70px / $layout-height) * 100%;
          margin: 0 auto;
          width: (856px / $layout-width) * 100%;
          height: (668px / $layout-height) * 100%;

          .dataBubbleList {
            width: 100%;
            display: flex;
            justify-content: space-around;
            padding-top: 38px;

            .dataBubble {
              cursor: pointer;

              &__header {
                color: #bad7ff;
                font-size: 16px;
                text-align: center;
              }
              &__content {
                width: 100px;
                height: 100px;
                margin: -13px auto 0 auto;
                background-color: red;
                border-radius: 50%;
                line-height: 100px;
                text-align: center;
                font-size: 42px;
                font-family: "IMPACT";
              }
              &:nth-child(1) {
                .dataBubble__content {
                  color: #3bafff;
                  background: linear-gradient(
                    transparent,
                    rgba(0, 138, 255, 0),
                    rgba(67, 72, 255, 0.2),
                    rgba(67, 72, 255, 0.5)
                  );
                }
              }
              &:nth-child(2) {
                .dataBubble__content {
                  color: #f1bb4c;
                  background: linear-gradient(
                    transparent,
                    rgba(241, 187, 76, 0),
                    rgba(215, 107, 20, 0.2),
                    rgba(215, 107, 20, 0.5)
                  );
                }
              }
              &:nth-child(3) {
                .dataBubble__content {
                  color: #afa3f5;
                  background: linear-gradient(
                    transparent,
                    rgba(175, 163, 245, 0),
                    rgba(105, 85, 255, 0.2),
                    rgba(105, 85, 255, 0.5)
                  );
                }
              }
              &:nth-child(4) {
                .dataBubble__content {
                  color: #e98f6c;
                  background: linear-gradient(
                    transparent,
                    rgba(233, 143, 108, 0),
                    rgba(243, 51, 0, 0.2),
                    rgba(243, 51, 0, 0.5)
                  );
                }
              }
              &:nth-child(5) {
                .dataBubble__content {
                  color: #3feed4;
                  background: linear-gradient(
                    transparent,
                    rgba(63, 238, 212, 0),
                    rgba(0, 161, 76, 0.2),
                    rgba(0, 161, 76, 0.5)
                  );
                }
              }
            }
          }
        }

        &.topRight {
          right: (10px / $layout-width) * 100%;
          top: (70px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (611px / $layout-height) * 100%;
          background-image: url("../../../assets/images/monitorBorad/leftBorder.png");
        }

        &.middleLeft {
          left: (10px / $layout-width) * 100%;
          top: (708px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (351px / $layout-height) * 100%;
          background-image: url("../../../assets/images/monitorBorad/topBorder.png");
        }

        &.middleCenter {
          left: 0;
          right: 0;
          top: (250px / $layout-height) * 100%;
          margin: 0 auto;
          width: (856px / $layout-width) * 100%;
          height: (826px / $layout-height) * 100%;
        }

        &.middleRight {
          right: (10px / $layout-width) * 100%;
          top: (708px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (351px / $layout-height) * 100%;
          background-image: url("../../../assets/images/monitorBorad/topBorder.png");
        }

        &-slide {
          position: absolute;
          top: 7px;
          right: 25px;
          display: flex;
          z-index: 10;

          li {
            margin-left: 3px;
            padding: 5px 6px;
            font-size: 12px;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: #fff;
              background: #7b89dc;
              border-radius: 5px;
            }
          }
        }

        &-chartArea {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.figure-data {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 0.14rem;
  color: #686868;
}
</style>
